import React from 'react';
import { resolveColorStyle } from '../../_helpers';

export function CustomMarker({ template }) {
  console.log('CustomMarker: ', template);
  let mode = 'img';
  return (
    <div className="chronos-custom-marker-display">
      {mode === 'img' && <CustomMarkerImage template={template} />}
      {mode === 'icon' && <CustomMarkerIcon template={template} />}
    </div>
  );
}

function CustomMarkerImage({ template }) {
  const { pinImg, primaryColor } = template;
  let filter = '';
  if (primaryColor !== null && primaryColor !== '') {
    try {
      filter = resolveColorStyle(primaryColor.slice()).filter;
    } catch (err) {
      console.log(
        '[CHRONOS] Unable to apply hue-shift. Invalid color or format.'
      );
    }
  }
  return (
    <img
      src={`https://www.worldanvil.com/${pinImg.path}`}
      style={{ filter, maxHeight: '100%' }}
    />
  );
}

function CustomMarkerIcon() {
  return 'Icon';
}
